import { create } from 'zustand';

export interface UpdateState {
	available: boolean;
	version: string | null;
	downloading: boolean;
	progress: number;
	error: string | null;
	dismissed: boolean;
	setAvailable: (version: string) => void;
	setDownloading: (downloading: boolean) => void;
	setProgress: (progress: number) => void;
	setError: (error: string) => void;
	dismiss: () => void;
	reset: () => void;
}

export const useUpdateStore = create<UpdateState>((set) => ({
	available: false,
	version: null,
	downloading: false,
	progress: 0,
	error: null,
	dismissed: false,
	setAvailable: (version) => set({ available: true, version, dismissed: false }),
	setDownloading: (downloading) => set({ downloading }),
	setProgress: (progress) => set({ progress }),
	setError: (error) => set({ error }),
	dismiss: () => set({ dismissed: true }),
	reset: () => set({ available: false, version: null, downloading: false, progress: 0, error: null, dismissed: false }),
}));
